<template>
  <div class="title">
    <div class="t-left">
      <div class="l-top">
        <p class="text">{{ gettitle(title) }}</p>
        <p class="text2" v-if="extend">/</p>
        <p class="text2" v-if="extend">{{ extend }}</p>
        <div class="more-btn" @click="tomore" v-if="isMore">查看更多></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from '@/components/scopetitle/method.js'
export default {
  name: 'scopetitle.textTitle1',
  props: {
    title: {
      type: [String, Object],
      default: ""
    },
    isMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      extend: ''
    };
  },
  watch: {},
  methods: {
    ...methods
  },
  mounted() { },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "YouSheBiaoTiHei";
  src: url("../../assets/fonts/YouSheBiaoTiHei.woff2");
}

.title {
  width: 435px;
  height: 40px;
}

.t-left {
  .l-top {
    width: 911px;
    height: 40px;
    background: url('@/assets/temimg9/title-wide.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 2px 0 0 40px;
    display: flex;
    align-items: center;

    .text {
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: 20px;
      color: #FFFFFF;
    }
    .text2 {
      margin-left: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #8798AC;
      line-height: 12px;
    }

    .more-btn {
      margin: 0 24px 0 auto;
      font-size: 14px;
      color: #51a0f4;
      cursor: pointer;
      pointer-events: auto;
    }
  }
}
</style>